var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-mit-menu"},[_c('BaseMitMenuHeader',{attrs:{"userModel":_vm.userModel}}),_c('v-divider'),_c('v-list',{attrs:{"nav":"","dense":""}},[_c('MitMenuAdmin'),_c('MitMenuHR'),_c('MitMenuUser'),_c('MitMenu')],1),_c('v-divider'),_c('BaseMitMenuFooter',{attrs:{"userModel":_vm.userModel},on:{"logout":_vm.logout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }